import React, { useEffect } from "react";
import Spinner from "../components/Indicators/Spinner";
import Error from "../components/Indicators/Error";

import { useDispatch, useSelector } from "react-redux";
import { getCodeFromURL } from "utils/auth.utils";
import { requestLogin, loginFailed } from "redux/Login/Login.actions";
import { useHistory } from "react-router";
import { StoreState } from "models";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import { ValmetCommonHighlight, ValmetGrey6 } from "theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centeredContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "50vh",
      maxHeight: "500px",
      minHeight: "300px",
    },
    messageContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    loginButton: {
      color: "white",
      border: "0",
      cursor: "pointer",
      padding: "20px",
      fontSize: "19px",
      borderRadius: "3px",
      marginBottom: "25px",
      backgroundColor: ValmetGrey6,
      boxShadow: "0px 0px 6px 3px rgb(0 0 0 / 9%)",
      width: "200px",
      "&:hover": {
        background: ValmetCommonHighlight,
      },
    },
  }),
);

const LoginView = () => {
  const localClasses = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const configuration = (window as any).configuration;
  const isLoggedIn: boolean = useSelector((state: StoreState) => state.login.isLoggedIn);
  const isLoggingIn: boolean = useSelector((state: StoreState) => state.login.isLoggingIn);
  const loginFailure: string = useSelector((state: StoreState) => state.login.loginFailure);

  const debugMode = configuration.debug ? configuration.debug : false;
  const SP_URL = configuration.spUrl;
  const SP_RESPONSE_TYPE = configuration.sp_response_type;
  const SP_SCOPE = configuration.sp_scope;
  const SP_STATE = configuration.sp_state;
  const SP_CLIENT_ID = configuration.sp_clientId;
  const SP_REDIRECT_URL = configuration.sp_redirectUri;

  const SP_IDENTITY_CUSTOMER = configuration.sp_identity_provider_customer;
  const LOGIN_URL_CUSTOMER = `${SP_URL}?response_type=${SP_RESPONSE_TYPE}&idp1&scope=${SP_SCOPE}&state=${SP_STATE}&client_id=${SP_CLIENT_ID}&identity_provider=${SP_IDENTITY_CUSTOMER}&redirect_uri=${SP_REDIRECT_URL}`;
  const SP_IDENTITY_INTERNAL = configuration.sp_identity_provider_internal;
  const LOGIN_URL_INTERNAL = `${SP_URL}?response_type=${SP_RESPONSE_TYPE}&idp2&scope=${SP_SCOPE}&state=${SP_STATE}&client_id=${SP_CLIENT_ID}&identity_provider=${SP_IDENTITY_INTERNAL}&redirect_uri=${SP_REDIRECT_URL}`;

  useEffect(() => {
    (window as any).valmet = (function () {
      function login(userType: "customer" | "internal") {
        sessionStorage.clear();
        window.location.href = userType === "customer" ? LOGIN_URL_CUSTOMER : LOGIN_URL_INTERNAL;
      }

      return {
        logOut: function () {
          sessionStorage.clear();
          return "sessionStorage cleared!";
        },
        loginAsInternal: function () {
          login("internal");
        },
        loginAsCustomer: function () {
          login("customer");
        },
      };
    })();
    if (isLoggedIn) {
      history.push("/cfd/fuel-composition");
    }
  }, [isLoggedIn, history, LOGIN_URL_CUSTOMER, LOGIN_URL_INTERNAL]);

  useEffect(() => {
    const authCode = getCodeFromURL();
    const token = sessionStorage.getItem("cfdui_id_token");

    if (authCode) {
      let body = `grant_type=authorization_code&client_id=${configuration.sp_clientId}&code=${authCode}&redirect_uri=${SP_REDIRECT_URL}`;

      (async () => {
        try {
          const response = await fetch(`${configuration.refreshUrl}`, {
            headers: new Headers({
              "Content-Type": "application/x-www-form-urlencoded",
            }),
            method: "post",
            body,
          });

          const { id_token, refresh_token } = await response.json();
          dispatch(requestLogin(id_token, refresh_token));
        } catch (error) {
          console.error(error);
          dispatch(loginFailed((error as { message: string })?.message));
        }
      })();
    } else {
      if (token) {
        dispatch(requestLogin("", ""));
      } else {
        console.info("You are not authenticated");
        if (debugMode) {
          window.location.href = LOGIN_URL_INTERNAL;
        } else {
          window.location.href = LOGIN_URL_CUSTOMER;
        }
      }
    }
  }, [dispatch, SP_REDIRECT_URL, LOGIN_URL_INTERNAL, LOGIN_URL_CUSTOMER, configuration, debugMode]);

  const renderContent = () => {
    if (isLoggingIn && !loginFailure) {
      return <Spinner message="Authenticating"></Spinner>;
    }

    if (loginFailure) {
      return <Error message={loginFailure}></Error>;
    }
  };

  return (
    <div className={localClasses.centeredContainer}>
      <div className={localClasses.messageContainer}>{renderContent()}</div>
    </div>
  );
};

export default LoginView;
